/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ingeritedcapacity1Inputs */

const en__field_ingeritedcapacity1 = /** @type {(inputs: _Field_Ingeritedcapacity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacity`)
};

const de__field_ingeritedcapacity1 = /** @type {(inputs: _Field_Ingeritedcapacity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapazität`)
};

/**
* | output |
* | --- |
* | "Capacity" |
*
* @param {_Field_Ingeritedcapacity1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_ingeritedcapacity1 = /** @type {((inputs?: _Field_Ingeritedcapacity1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ingeritedcapacity1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_ingeritedcapacity1(inputs)
	return de__field_ingeritedcapacity1(inputs)
});
export { _field_ingeritedcapacity1 as "_field_ingeritedCapacity" }